import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import './ModernEventCard.css';

const ModernEventCard = ({ event }) => {
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <div className="yk-event-card-modern">
                {/* Event Image */}
                <div className="yk-event-image-wrapper" onClick={handleShowModal}>
                    <img 
                        src={event.imgsrc} 
                        alt={event.title}
                        className="yk-event-image"
                        loading="lazy"
                    />
                    <div className="yk-event-overlay">
                        <div className="yk-event-overlay-content">
                            <i className="fas fa-search-plus"></i>
                            <span>View Flyer</span>
                        </div>
                    </div>
                </div>

                {/* Event Content */}
                <div className="yk-event-content">
                    {/* Event Title */}
                    <h3 className="yk-event-title">
                        {event.titleHtml ? (
                            <span dangerouslySetInnerHTML={{ __html: event.titleHtml }} />
                        ) : (
                            event.title
                        )}
                    </h3>

                    {/* Event Actions */}
                    <div className="yk-event-actions">
                        {event.lablename === 'Register Now' ? (
                            <a 
                                href={event.links} 
                                target="_blank"
                                rel="noreferrer"
                                className="yk-event-btn yk-btn-primary"
                            >
                                <i className="fas fa-user-plus"></i>
                                Register Now
                            </a>
                        ) : (
                            <button 
                                onClick={handleShowModal}
                                className="yk-event-btn yk-btn-primary"
                            >
                                <i className="fas fa-eye"></i>
                                View Flyer
                            </button>
                        )}
                        
                        {event.pagelinks && (
                            <Link 
                                to={event.pagelinks}
                                className="yk-event-btn yk-btn-secondary"
                            >
                                <i className="fas fa-info-circle"></i>
                                Learn More
                            </Link>
                        )}
                    </div>
                </div>
            </div>

            {/* Flyer Modal */}
            <Modal 
                show={showModal} 
                onHide={handleCloseModal} 
                size="lg" 
                centered
                className="yk-event-modal"
            >
                <Modal.Header closeButton className="yk-modal-header">
                    <Modal.Title>
                        {event.titleHtml ? (
                            <span dangerouslySetInnerHTML={{ __html: event.titleHtml }} />
                        ) : (
                            event.title
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="yk-modal-body">
                    <img 
                        src={event.imglinks || event.imgsrc} 
                        alt={event.title}
                        className="yk-modal-image"
                    />
                </Modal.Body>
                <Modal.Footer className="yk-modal-footer">
                    <a 
                        href={event.imglinks || event.imgsrc} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="yk-modal-btn yk-btn-download"
                        download
                    >
                        <i className="fas fa-download"></i>
                        Download Flyer
                    </a>
                    <button 
                        className="yk-modal-btn yk-btn-close" 
                        onClick={handleCloseModal}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModernEventCard;
